import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  margin: 14px 14px 0;
  padding: 16px;
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  border: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 900;
  font-size: 16px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 5px;
`;
